export { Home } from './Home'


// WEBPACK FOOTER //
// ./src/App/Admin/Home/index.js